import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { MultiSelectMobile } from '../MultiSelectMobile';
import { MultiSelectDesktop } from '../MultiSelectDesktop';
import { useControlledValue } from '../../internal';

/**
 * Адаптивный select-компонент для выбора нескольких значений из списка
 *
 * * Десктопный вариант открывает выпадающий список
 * * Мобильный вариант открывает список в модальном окне
 */
export var MultiSelect = /*#__PURE__*/React.forwardRef(function MultiSelect(props, ref) {
  var deviceType = useDeviceType();
  var _useControlledValue = useControlledValue(props, []),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  if (deviceType === 'phone') {
    return /*#__PURE__*/React.createElement(MultiSelectMobile, _extends({}, props, {
      ref: ref,
      value: value,
      onChange: onChange
    }));
  }
  return /*#__PURE__*/React.createElement(MultiSelectDesktop, _extends({}, props, {
    ref: ref,
    value: value,
    onChange: onChange
  }));
});